// NPM
import * as React from "react"
import { graphql } from "gatsby"
import _ from "lodash"

// Components
import Layout from "src/layouts/fr"
import Contact from "src/components/pages/Contact/Contact"

const ContactPageFr = ({ location, data }) => {
  const topNav = data.topNav
  const sections = _.get(data, `contactPage.sections`, [])
  const contactForm = _.get(data, `contactForm`)
  const testimonials = _.get(data, `testimonials.nodes`, [])
  const bottomNav = data.bottomNav
  const socialMedia = _.get(data, `socialMedia.nodes`, [])

  return (
    <Layout
      location={location}
      topNav={topNav}
      page={data.contactPage}
      bottomNav={bottomNav}
      socialMedia={socialMedia}
    >
      <Contact
        sections={sections}
        contactForm={contactForm}
        testimonials={testimonials}
      />
    </Layout>
  )
}

export default ContactPageFr

export const query = graphql`
  query ContactPageFrQuery($id: String) {
    topNav: strapiTopNav(locale: { eq: "fr" }) {
      ...topNavContent
    }

    contactPage: strapiPage(id: { eq: $id }) {
      ...pageInformation
    }

    contactForm: strapiContactForm(locale: { eq: "fr" }) {
      fields: strapi_fields {
        uuid
        strapi_component
        placeholder
        order
        name
        options {
          label
          order
          value
        }
      }

      submitText
    }

    testimonials: allStrapiTestimonial(filter: { locale: { eq: "fr" } }) {
      nodes {
        name
        quote
        credit
        order
      }
    }

    bottomNav: strapiBottomNav(locale: { eq: "fr" }) {
      ...bottomNavContent
    }

    socialMedia: allStrapiSocialMedia(filter: { locale: { eq: "fr" } }) {
      nodes {
        ...socialMedia
      }
    }
  }
`
